export interface BillingDetails {
  id: string;
  name: string;
  address: string;
  state: string;
  stateId: number;
  country: string;
  countryId: number;
  city: string;
  cityId: number;
  pincode: string;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertBillingDetailsDto {
  name: string;
  address: string;
  state?: string;
  stateId?: number;
  country: string;
  countryId: number;
  city: string;
  cityId?: number;
  pincode: string;
}

export interface CardDetails {
  paymentMethodId: string;
  name: string | null;
  cardName: string;
  isDefault: boolean;
  last4: string;
}

export enum PlanType {
  StarterPlan = 'Starter Plan',
  CreatorPlan = 'Creator Plan',
  ProPlan = 'Pro Plan',
  AllAccessPlan = 'All Access Plan',
}

export interface PaymentHistoryItem {
  id: string;
  date: string;
  planName: string;
  amount: number;
  currency: string;
  status: 'Pending' | 'InProgress' | 'Completed' | 'Failed' | 'Canceled';
  receiptId?: string;
  errorCode?: string;
  errorMessage?: string;
  ghlSubscriptionId?: string;
}
